import { render } from "./Privilege.vue?vue&type=template&id=5cf7beb7&scoped=true"
import script from "./Privilege.vue?vue&type=script&lang=js"
export * from "./Privilege.vue?vue&type=script&lang=js"

import "./Privilege.vue?vue&type=style&index=0&id=5cf7beb7&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf7beb7"]])

export default __exports__